<template>
  <div>
    <UserDataProvider v-slot="{user, loaded}">
      <v-list
        v-if="loaded"
        :dense="$vuetify.breakpoint.mdAndUp"
        flat
        class="pt-0"
      >
        <template v-if="showExternals(user)">
          <v-divider></v-divider>
          <template
            v-for="(item, index) in filteredExternals(user)"
          >
            <v-list-item
              :key="index"
              :href="item.href"
              :target="item.target"
            >
              <v-list-item-icon>
                <v-icon>{{item.icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text[$i18n.locale]"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
          <template v-if="displayDefaults">
            <v-divider></v-divider>
            <v-list-item
              v-if="isLocalized"
              @click="changeLocale(nextLocale.value)"
            >
              <v-list-item-icon>
                <v-icon>$mdiTranslate</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ nextLocale.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        <v-divider></v-divider>
        <v-list-item
          replace
          exact
          @click="signOut"
          active-class="active-nav-item"
        >
          <v-list-item-icon>
            <v-icon>$mdiLogoutVariant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('LOGOUT') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </UserDataProvider>
    <div class="pl-5 caption text--secondary">v{{ version }}</div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { logOut } from '@/libs/Auth'
import UserDataProvider from '@/components/frames/UserDataProvider'

export default {
  name: 'NavFooter',
  components: {
    UserDataProvider
  },
  props: {
    isLocalized: {
      type: Boolean,
      default: true
    },
    externals: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    version: process.env.VUE_APP_SPA_VERSION
  }),
  computed: {
    displayDefaults () {
      return this.isLocalized
    },
    ...mapState(
      'preferences',
      ['locale']
    ),
    ...mapGetters(
      'preferences',
      ['locales']
    ),
    nextLocale () {
      const value = this.locales.find(item => item.value !== this.locale)
      return value
    }
  },
  methods: {
    showExternals (user) {
      return (this.filteredExternals(user)).length
    },
    filteredExternals (user) {
      const filtered = this.externals.filter((item) => {
        const enabled = !('disabled' in item) || ('disabled' in item ? !item.disabled : true)
        const hasAccess = !('accessType' in item) || item.accessType.length === 0 || item.accessType.includes(user.accessType)
        return enabled && hasAccess
      })
      return filtered
    },
    changeLocale (value) {
      this.$store.dispatch('preferences/setLocale', value)
    },
    signOut () {
      logOut()
    }
  }
}
</script>

<i18n>
{
  "fr": {
    "LOGOUT": "Déconnexion",
    "PROFILE": "Modifier le profil",
    "PASSWORD": "Changer mot de passe"
  },
  "en": {
    "LOGOUT": "Logout",
    "PROFILE": "Profile edit",
    "PASSWORD": "Change password"
  }
}
</i18n>
